import { RadialChartBlock } from "../../../../src/lib/annual-report/radial-chart-block/radial-chart-block";
import * as React from 'react';
export default {
  RadialChartBlock,
  React
};